import {Paper, Stack, Typography} from '@mui/material';
import CreditCardIcon from '$assets/svgs/credit-card-x.svg?react';
import {cardStyle} from '../../styles';
import {
  amountStyle,
  descriptionStyle,
  titleStyle,
  totalAmountStyle,
} from './styles';
import {DashboardData} from '$api/finance/dashboard';

interface OutstandingPaymentsCardProps {
  data: DashboardData;
}

const OutstandingPaymentsCard: React.FC<OutstandingPaymentsCardProps> = ({
  data,
}) => {
  const {unpaid_invoice_count, total_outstanding} = data.outstanding_payments;
  return (
    <Paper sx={cardStyle}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <CreditCardIcon />
        <Typography variant="h6" sx={titleStyle}>
          Outstanding payments
        </Typography>
      </Stack>
      <Typography variant="h2" sx={amountStyle}>
        {unpaid_invoice_count}
      </Typography>
      <Typography sx={descriptionStyle}>unpaid invoices</Typography>
      <Typography sx={totalAmountStyle}>
        Totalling £{total_outstanding.toLocaleString()}
      </Typography>
    </Paper>
  );
};

export default OutstandingPaymentsCard;
